export enum HttpMethods {
	GET = 'GET',
	PATCH = 'PATCH',
	POST = 'POST',
	PUT = 'PUT',
	DELETE = 'DELETE'
}
export enum Status {
	idle = 'idle',
	pending = 'pending',
	resolved = 'resolved',
	rejected = 'rejected',
	isSubmitting = 'false',
	isSubmitted = 'false'
}

// urls
export enum EndPoints {
	todo = '/todo'
}
